module.exports = __webpack_public_path__ + "static/media/Thumb.309cc66b.png";